<template>
  <div class="ask_my_paper_box">
    <MyPanel
      :user-info-data="userInfoData"
      :data="enrollData"
      @fileChange="fileChange"
    />

    <div v-if="enrollData.id && props.batchData.id">
      <div v-if="enrollData.checkState == 5">
        <!-- 论文计划 -->
        <div class="view_box">
          <div class="title_box">
            <img class="img" src="@/assets/t_icon.png" alt="" />
            <span>学位论文</span>
          </div>
          <a-descriptions
            title=""
            bordered
            :column="2"
            :label-style="{
              'text-align': 'right',
              color: '#666666',
              width: '170px',
            }"
            :content-style="{ color: '#666666', flex: '1' }"
          >
            <template v-if="props.batchData.proposalReport">
              <a-descriptions-item :column="1" label="开题报告提交时间">
                <div class="value_box">
                  {{
                    timeFormat2(
                      props.batchData.proposalReportStartTime,
                      props.batchData.proposalReportEndTime
                    )
                  }}
                  <span
                    class="des_item_s1 ml10"
                    @click="noticeChange('proposalReportNotice')"
                    >开题须知</span
                  >
                </div>
              </a-descriptions-item>
              <a-descriptions-item
                :column="1"
                :label="enrollData.proposalReportFile ? '已提交' : '未提交'"
              >
                <div class="value_box">
                  <div v-if="!enrollData.proposalReportFile">
                    <UploadFileBox tip-state @change="fileChange($event, 1)">
                      <span class="des_item_s1">立即提交</span>
                    </UploadFileBox>
                  </div>
                  <span
                    v-else
                    class="des_item_s1"
                    @click="
                      downLoad({
                        url: enrollData.proposalReportFile,
                        name: '开题报告',
                      })
                    "
                    >点击下载</span
                  >
                </div>
              </a-descriptions-item>
            </template>

            <a-descriptions-item :column="1" label="一稿论文提交时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    enrollData.submission1StartTime,
                    enrollData.submission1EndTime
                  )
                }}
                <span
                  v-if="props.batchData.enablePaperSubmitNotice"
                  class="des_item_s1 ml10"
                  @click="noticeChange('paperSubmitNotice')"
                  >提交须知</span
                >
              </div>
            </a-descriptions-item>
            <a-descriptions-item
              :column="1"
              :label="review[enrollData.submission1CheckState || 0]"
            >
              <div class="value_box">
                <span v-if="enrollData.submission1CheckState == 3" class="txt1">
                  {{ enrollData.submission1CheckNoPassMessage }}
                </span>
                <span v-else-if="enrollData.submission1CheckState == 2">
                  已通过
                </span>
                <span v-else-if="enrollData.submission1CheckState == 1">
                  审核中
                  <span class="des_item_s1" @click="subChange(1)"
                    >重新提交</span
                  >
                </span>
                <div v-else>
                  <span class="des_item_s1" @click="subChange(1)"
                    >立即提交</span
                  >
                </div>
              </div>
            </a-descriptions-item>
            <template
              v-if="
                props.batchData.submissionNum > 1 &&
                enrollData.submission1CheckState == 3
              "
            >
              <a-descriptions-item :column="1" label="二稿论文提交时间">
                <div class="value_box">
                  {{
                    timeFormat2(
                      enrollData.submission2StartTime,
                      enrollData.submission2EndTime
                    )
                  }}
                  <span
                    v-if="props.batchData.enablePaperSubmitNotice"
                    class="des_item_s1 ml10"
                    @click="noticeChange('paperSubmitNotice')"
                    >提交须知</span
                  >
                </div>
              </a-descriptions-item>
              <a-descriptions-item :column="1">
                <template #label>
                  <span>{{
                    review[enrollData.submission2CheckState || 0]
                  }}</span>
                </template>
                <div class="value_box">
                  <span
                    v-if="enrollData.submission2CheckState == 3"
                    class="txt1"
                  >
                    {{ enrollData.submission2CheckNoPassMessage }}
                  </span>
                  <span v-else-if="enrollData.submission2CheckState == 2">
                    已通过
                  </span>
                  <span v-else-if="enrollData.submission2CheckState == 1">
                    审核中
                    <span class="des_item_s1" @click="subChange(2)"
                      >重新提交</span
                    >
                  </span>
                  <div v-else>
                    <span class="des_item_s1" @click="subChange(2)"
                      >立即提交</span
                    >
                  </div>
                </div>
              </a-descriptions-item>
            </template>
            <template
              v-if="
                props.batchData.submissionNum > 2 &&
                enrollData.submission2CheckState == 3
              "
            >
              <a-descriptions-item :column="1" label="三稿论文提交时间">
                <div class="value_box">
                  {{
                    timeFormat2(
                      enrollData.submission3StartTime,
                      enrollData.submission3EndTime
                    )
                  }}
                  <span
                    v-if="props.batchData.enablePaperSubmitNotice"
                    class="des_item_s1 ml10"
                    @click="noticeChange('paperSubmitNotice')"
                    >提交须知</span
                  >
                </div>
              </a-descriptions-item>
              <a-descriptions-item :column="1">
                <template #label>
                  <span>{{
                    review[enrollData.submission3CheckState || 0]
                  }}</span>
                </template>
                <div class="value_box">
                  <span
                    v-if="enrollData.submission3CheckState == 3"
                    class="txt1"
                  >
                    {{ enrollData.submission3CheckNoPassMessage }}
                  </span>
                  <span v-else-if="enrollData.submission3CheckState == 2">
                    已通过
                  </span>
                  <span v-else-if="enrollData.submission3CheckState == 1">
                    审核中
                    <span class="des_item_s1" @click="subChange(3)"
                      >重新提交</span
                    >
                  </span>
                  <div v-else>
                    <span class="des_item_s1" @click="subChange(3)"
                      >立即提交</span
                    >
                  </div>
                </div>
              </a-descriptions-item>
            </template>
          </a-descriptions>
        </div>

        <!-- 答辩 -->
        <div v-if="enrollData.isReply" class="view_box">
          <div class="title_box">
            <img class="img" src="@/assets/t_icon.png" alt="" />
            <span>论文答辩</span>
          </div>
          <a-descriptions
            title=""
            bordered
            :column="2"
            :label-style="{
              'text-align': 'right',
              color: '#666666',
              width: '170px',
            }"
            :content-style="{ color: '#666666', flex: '1' }"
          >
            <a-descriptions-item :column="1" label="答辩论文提交时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    enrollData.replyStartTime,
                    enrollData.replyEndTime
                  )
                }}
              </div>
            </a-descriptions-item>
            <template
              v-if="
                (enrollData.replyCheckState == 1 &&
                  enrollData.replyPaperFile) ||
                enrollData.replyCheckState == 4
              "
            >
              <a-descriptions-item :column="1">
                <template #label>
                  <span>{{ reply[enrollData.replyCheckState || 0].txt }}</span>
                </template>
                <div class="value_box">
                  <span
                    v-if="
                      enrollData.replyCheckState == 1 ||
                      enrollData.replyCheckState == 4
                    "
                  >
                    <span
                      class="des_item_s1"
                      :style="{ color: reply[enrollData.replyCheckState].col }"
                      @click="subChange(0)"
                    >
                      重新上传
                    </span>
                    <p v-show="enrollData.replyCheckState == 4" class="txt1">
                      {{ enrollData.replyCheckNoPassMsg }}
                    </p>
                  </span>
                  <span
                    v-if="
                      enrollData.replyCheckState == 1 ||
                      enrollData.replyCheckState == 2
                    "
                    class="des_item_s1"
                    @click="
                      downLoad({
                        url: enrollData.replyPaperFile,
                        name: '答辩论文',
                      })
                    "
                  >
                    点击下载
                  </span>
                </div>
              </a-descriptions-item>
            </template>
            <a-descriptions-item :column="1" label="答辩证下载时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    enrollData.replyCertStartTime,
                    enrollData.replyCertEndTime
                  )
                }}
                <span
                  class="des_item_s1 ml10"
                  @click="noticeChange('replyNotice', 1)"
                  >下载答辩证</span
                >
              </div>
            </a-descriptions-item>
            <template v-if="enrollData.replyPaperSubmitTime">
              <a-descriptions-item :column="1" label="提交时间">
                <div class="value_box">
                  <span class="des_item_s1 des_item_s2">
                    {{ timeFormat(enrollData.replyPaperSubmitTime, 1) }}
                  </span>
                </div>
              </a-descriptions-item>
            </template>
            <a-descriptions-item :column="1" label="论文答辩起止时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    enrollData.replyCertStartTime,
                    enrollData.replyCertEndTime
                  )
                }}
              </div>
            </a-descriptions-item>
            <a-descriptions-item :column="1" label="答辩地点">
              <div class="value_box">{{ enrollData.replyAddress }}</div>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>

      <!-- {{enrollData.isReply}}---{{enrollData.checkState}} -->
      <!-- 培训 -->
      <div
        v-if="
          enrollData.isTrain &&
          enrollData.checkState != 1 &&
          enrollData.checkState != 3
        "
        class="view_box"
      >
        <div class="title_box">
          <img class="img" src="@/assets/t_icon.png" alt="" />
          <span>学位申请</span>
        </div>
        <a-descriptions
          title=""
          bordered
          :column="2"
          :label-style="{
            'text-align': 'right',
            color: '#666666',
            width: '170px',
          }"
          :content-style="{ color: '#666666', flex: '1' }"
        >
          <a-descriptions-item :column="1" label="论文培训报名时间">
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.trainStartTime,
                  props.batchData.trainEndTime
                )
              }}
              <span
                class="des_item_s1 ml10"
                @click="noticeChange('trainSignUpNotice')"
                >报名须知</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1">
            <template #label>
              <span>
                {{ train[enrollData.trainState || 0].txt }}
              </span>
            </template>
            <div class="value_box descriptions_item_value">
              <span
                v-if="!enrollData.trainState"
                class="des_item_s1"
                @click="trainEnrollChange()"
              >
                {{ train[enrollData.trainState || 0].txt2 }}
              </span>
              <span
                v-else-if="enrollData.trainState == 5"
                :style="{ color: train[0].col }"
              >
                {{ timeFormat(enrollData.trainSignTime) }}
              </span>
              <span v-else class="des_item_s1" @click="trainEnrollChange()">
                {{ train[enrollData.trainState || 0].txt2 }}
              </span>
              <div
                v-if="enrollData.trainState == 3 || enrollData.trainState == 6"
              >
                {{ enrollData.trainNoPassMessage }}
              </div>
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="论文培训缴费时间">
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.trainPayStartTime,
                  props.batchData.trainPayEndTime
                )
              }}
              <span
                class="des_item_s1 ml10"
                @click="noticeChange('trainPayNotice')"
                >缴费须知</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="缴费金额">
            <div class="value_box">{{ enrollData.trainPay || "-" }}元</div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="准培证下载时间">
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.trainCertStart,
                  props.batchData.trainCertEnd
                )
              }}
              <span
                class="des_item_s1 ml10"
                @click="noticeChange('trainCertNotice', 2)"
                >下载准培证</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="报名时间">
            <div class="value_box">
              {{ timeFormat(enrollData.trainCheckTime) || "-" }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="论文培训起止时间">
            <div class="value_box">
              {{
                timeFormat2(enrollData.trainStartTime, enrollData.trainEndTime)
              }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="培训地点">
            <div class="value_box">{{ enrollData.trainAddress }}</div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <div v-if="enrollData.checkState" class="view_box">
        <div class="title_box">
          <img class="img" src="@/assets/t_icon.png" alt="" />
          <span>学位申请报名审核</span>
        </div>
        <a-descriptions
          title=""
          bordered
          :column="2"
          :label-style="{
            'text-align': 'right',
            color: '#666666',
            width: '170px',
          }"
          :content-style="{ color: '#666666', flex: '1' }"
        >
          <a-descriptions-item :column="1" label="论文报名起止时间">
            <div class="value_box">
              {{
                timeFormat2(
                  props.batchData.signUpStartTime,
                  props.batchData.signUpEndTime
                )
              }}
              <span class="des_item_s1 ml10" @click="noticeChange('signNotice')"
                >报名须知</span
              >
            </div>
          </a-descriptions-item>
          <a-descriptions-item :column="1">
            <template #label>
              <span>
                {{ signup[enrollData.checkState].txt }}
              </span>
            </template>
            <div class="value_box">
              <span
                v-if="enrollData.checkState == 5"
                :style="{ color: signup[enrollData.checkState].col }"
              >
                {{ timeFormat(enrollData.checkTime) }}
              </span>
              <span
                v-else
                class="des_item_s1"
                @click="operateChange(enrollData)"
              >
                {{ signup[enrollData.checkState].txt2 }}
              </span>
              <span class="download_text" @click="openCheckChange">
                查看报名材料
              </span>
              <span
                v-if="
                  !studentAccountData.selfStudyCertificateNumber ||
                  !studentAccountData.moeRegistration ||
                  !studentAccountData.idPhoto
                "
                class="download_text"
                @click="supplementGraduationMaterials"
              >
                补充毕业材料
              </span>
              <div
                v-if="enrollData.checkState == 3 || enrollData.checkState == 6"
              >
                {{
                  enrollData.checkState == 3
                    ? enrollData.checkNoPassMsg
                    : enrollData.payCheckNoPassMsg
                }}
              </div>
            </div>
          </a-descriptions-item>
          <template v-if="props.batchData.enablePay">
            <a-descriptions-item :column="1" label="论文缴费起止时间">
              <div class="value_box">
                {{
                  timeFormat2(
                    props.batchData.payStartTime,
                    props.batchData.payEndTime
                  )
                }}
                <span
                  class="des_item_s1 ml10"
                  @click="noticeChange('payNotice')"
                  >缴费须知</span
                >
              </div>
            </a-descriptions-item>
            <a-descriptions-item :column="1" label="缴费金额">
              <div class="value_box">
                {{ props.batchData.signUpPay || "-" }}元
              </div>
            </a-descriptions-item>
          </template>

          <a-descriptions-item :column="1" label="论文报名审核备注">
            <!-- <div class="value_box">{{enrollData.payCheckNoPassMsg||"-"}}</div> -->
            <div class="value_box">{{ enrollData.checkNoPassMsg || "-" }}</div>
          </a-descriptions-item>
          <a-descriptions-item :column="1" label="报名缴费审核备注">
            <!-- <div class="value_box">{{enrollData.checkNoPassMsg||"-"}}</div> -->
            <div class="value_box">
              {{ enrollData.payCheckNoPassMsg || "-" }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty_box">
      <a-empty :image="simpleImage" />
    </div>

    <!-- 须知、下载 弹窗 -->
    <NoticeModel
      v-model:show="noticeData.show"
      :show-data="noticeData.showData"
      :cancel-text="noticeData.cancelText"
      :ok-text="noticeData.okText"
      @okChange="noticeOk"
    />

    <!-- 报名弹窗 -->
    <ModalInfoBox
      v-model:show="signUpData.show2"
      :title="signUpData.title"
      :data="signUpData.data"
      :step="1"
      @updateList="updateData"
    />

    <!-- 报名弹窗 -->
    <SignUpModel
      v-model:show="signUpData.show"
      :title="signUpData.title"
      :loading="signUpData.loading"
      :major-list="signUpData.majorList"
      :data="signUpData.data"
      @update-data="updateData"
    />

    <!-- 培训报名 -->
    <TrainModalBox
      v-model:show="trainData.show"
      :title="trainData.title"
      :data="trainData.data"
      @updateList="getApplicationData"
    />

    <!-- 论文提交弹窗 -->
    <SubmitModalBox
      v-model:show="submitData.show"
      :data="submitData.data"
      @updateList="updateData"
    />

    <!-- 报名详情弹窗 -->
    <ImmediatelyProcess
      v-model:visible="immediatelyProcessVisible"
      type="dissertation"
      :exam-ticket-num="enrollData.examTicketNum"
      :major-name="enrollData.majorName"
      :is-open="true"
    />

    <!-- 补充材料弹窗 -->
    <graduation-materials
      :id="enrollData.id"
      v-model:visible="graduationMaterialsVisible"
      type="dissertation"
      @updateList="updateGraduationMaterials"
      @cancel="cancelGraduationMaterials"
    />
  </div>
</template>

<script setup>
import { ref, reactive, watchEffect, defineProps } from "vue";
import { Empty, Modal } from "ant-design-vue";
import dayjs from "dayjs";

import {
  getPaperStudentMajorVO,
  uploadFile,
  paperCertDownload,
} from "@/api/my_page/paper/index.js";
import {
  timeFormat,
  timeFormat2,
  downLoad,
  downloadFile,
  imgUrlList,
} from "@/views/my_page/index.js";
import { getStudentAccount } from "@/api/my_page/student_info/index.js";
import { proposal, signup, review, review2, train, reply } from "./state.js";

import MyPanel from "@/views/my_page/thesis/components/myPanel.vue";
import NoticeModel from "@/views/my_page/components/noticeModel.vue";
import ModalInfoBox from "@/views/my_page/dissertation/components/modal_box.vue";
import TrainModalBox from "@/views/my_page/dissertation/components/train_modal.vue";
import UploadFileBox from "@/views/my_page/components/upload_file_box.vue";
import SubmitModalBox from "@/views/my_page/components/submit_modal.vue";
import SignUpModel from "@/views/my_page/components/signUpModel.vue";
import ImmediatelyProcess from "@/views/my-center/components/immediately-process.vue";
import GraduationMaterials from "@/views/my-center/components/graduation-materials.vue";

const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;

const props = defineProps({
  show: {
    type: Boolean,
  },
  batchIndex: {
    type: String,
  },
  batchData: {
    // 当前批次数据
    type: Object,
    default: () => {
      return {};
    },
  },
});

watchEffect(() => {
  if (props.show && props.batchIndex) {
    getApplicationData();
    getStudentAccountFn();
  }
});
const enrollData = ref({});
const userInfoData = ref({});

const studentAccountData = ref({});
function getStudentAccountFn() {
  getStudentAccount().then((res) => {
    studentAccountData.value = res;
  });
}
// 获取报名信息
function getApplicationData() {
  let params = {
    paperBatchId: props.batchIndex,
    paperType: 2,
  };
  getPaperStudentMajorVO(params)
    .then((res) => {
      // console.log("获取报名信息==", res);
      enrollData.value = res || {};

      // 用户信息
      userInfoData.value = {
        createTime: res.createTime,
        studentImage: res.studentImage,
        account: res.account,
        employeeName: res.employeeName,
        phoneNumber: res.phoneNumber,
        majorCode: res.majorCode,
        majorName: res.majorName,
        education: res.education,
      };

      // 留言板需要的数据
      let bData = props.batchData;
      let season = bData.season == "S" ? "春季" : "秋季";
      let paperType = bData.paperType == 1 ? "毕业论文" : "学位论文";
      enrollData.value.title = bData.year + season + paperType; // 标题
      enrollData.value.submissionNum = bData.submissionNum; // 稿次
      enrollData.value.proposalReport = bData.proposalReport; // 开题报告
    })
    .catch((err) => {
      console.log("err===", err);
    });
}

const immediatelyProcessVisible = ref(false);
//查看学位/毕业论文材料
const openCheckChange = () => {
  immediatelyProcessVisible.value = true;
};

const graduationMaterialsVisible = ref(false);
const isGraduationMaterialsShow = ref(false);
//补充学位/毕业论文材料
const supplementGraduationMaterials = () => {
  graduationMaterialsVisible.value = true;
};

// 须知弹窗
const noticeData = reactive({
  show: false,
  showData: {
    title: "",
    content: "",
  },
  cancelText: false,
  okText: "确定",
  type: undefined,
});
function noticeOk(callback) {
  if (noticeData.type) {
    let txtObj = {
      1: "答辩证",
      2: "培训证",
    };
    let parmas = {
      paperStudentMajorId: enrollData.value.id,
      downloadType: noticeData.type,
    };
    paperCertDownload(parmas)
      .then((res) => {
        callback();
        let time = dayjs().format("YYYY-MM-DD HH:mm:ss");
        downloadFile(res, {
          fileName: txtObj[noticeData.type] + " " + time,
          fileType: "pdf",
        });
      })
      .catch((err) => {
        console.log("下载失败err", err);
        // message.error("下载失败")
      });
    return;
  }
  callback();
}
function noticeChange(key, type) {
  noticeData.type = type;
  let titleObj = {
    proposalReportNotice: "开题须知", // 开题报告
    paperSubmitNotice: "提交须知", // 一稿提交
    replyNotice: "答辩证下载须知", // 答辩证下载
    trainSignUpNotice: "报名须知", // 培训报名
    trainPayNotice: "缴费须知", // 培训缴费
    trainCertNotice: "准培证下载须知", // 准培证下载
    signNotice: "报名须知", // 论文报名起止时间
    payNotice: "缴费须知", // 论文缴费起止时间
  };
  // let batchItem = props.batchData.find(item => item.id == props.batchIndex)
  noticeData.showData = {
    title: titleObj[key],
    content: props.batchData[key],
  };
  if (type) {
    noticeData.cancelText = "取消";
    noticeData.okText = "下载";
  } else {
    noticeData.cancelText = false;
    noticeData.okText = "确定";
  }

  noticeData.show = true;
}

// 报名
const signUpData = reactive({
  state: 1,
  // 弹窗
  show: false,
  show2: false,
  title: "",
  data: {},
  loading: false,
});
function operateChange(itemData) {
  // 打开报名弹窗
  // console.log("===", itemData);
  let name = signup[itemData.checkState].txt;
  signUpData.title = name;
  signUpData.data = {
    ...itemData,
    id: itemData.id,
    checkState: itemData.checkState, // 审核状态
    examTicketNum: itemData.examTicketNum, // 准考证号
    signUpImages: imgUrlList(itemData.signUpImages), // 报名提交的图片
    payImages: imgUrlList(itemData.payImages), // 缴费证明图片
    payTime: timeFormat(itemData.payTime, 1), // 缴费提交时间
    signUpTime: timeFormat(itemData.signUpTime, 1), // 报名时间
    majorId: itemData.majorId, //专业id
    paperBatchMajorId: itemData.paperBatchMajorId,
  };
  signUpData.majorList = [
    {
      value: itemData.majorId,
      label: itemData.majorName,
    },
  ];
  if (itemData.checkState == 2 || itemData.checkState > 3) {
    signUpData.show2 = true;
  } else {
    signUpData.show = true;
  }
}

// 培训报名
const trainData = reactive({
  show: false,
  title: "培训报名",
  data: {},
});
function trainEnrollChange() {
  trainData.data = {
    paperStudentMajorId: enrollData.value.id,
    checkState: enrollData.value.trainState,
    trainPaySubmitTime: timeFormat(enrollData.value.trainPaySubmitTime), // 缴费提交时间
    payImages: enrollData.value.trainPaySubmitImage, // 缴费照片
    notice: props.batchData.trainSignUpNotice,
  };

  // if (state == 2 || state == 6) {
  //   trainData.title = "培训缴费";
  // } else {
  //   trainData.title = "培训报名";
  // }
  trainData.show = true;
}

// 提交论文
const submitData = reactive({
  show: false,
  data: {},
});
function updateGraduationMaterials() {
  // 提交一稿时需要补充材料  补充完毕就可以上传论文了
  if (isGraduationMaterialsShow.value) {
    subChange(1);
  }
  getStudentAccountFn();
}
function cancelGraduationMaterials() {
  isGraduationMaterialsShow.value = false;
}
function subChange(submissionNum) {
  //一稿
  if (submissionNum == 1 && !isGraduationMaterialsShow.value) {
    Modal.confirm({
      title: "提示",
      content:
        "当获得自考毕业证号和教育部学历证书电子注册备案表后，需要进行对应材料补充，若未获得请暂时关闭当前弹窗，若已获得则点击继续。",
      cancelText: "关闭",
      okText: "点击继续",
      onOk: () => {
        graduationMaterialsVisible.value = true;
        isGraduationMaterialsShow.value = true;
      },
    });
    return;
  }
  // 2: 答辩论文
  // 3: 1稿论文
  // 4: 2稿论文
  // 5: 3稿论文
  let typeObj = {
    0: 2,
    1: 3,
    2: 4,
    3: 5,
  };
  submitData.data = {
    id: enrollData.value.id,
    submissionNum: submissionNum,
    type: typeObj[submissionNum],
  };
  submitData.show = true;
  cancelGraduationMaterials();
}

// 更新数据
function updateData() {
  getApplicationData();
}

// 上传文件
function fileChange(params, type) {
  let param = {
    paperStudentMajorId: enrollData.value.id,
    fileUrl: params,
    type,
  };
  uploadFile(param).then((res) => {
    // console.log("res", res);
    updateData();
  });
}
</script>

<style lang="scss" scoped>
@import "@/style/var.scss";
.ask_my_paper_box {
  width: 100%;
}

.title_box {
  margin: 20px 0 7px;
  display: flex;
  align-items: center;
  .img {
    width: 15px;
    margin-right: 3px;
  }
  span {
    font-weight: 600;
    color: #666666;
  }
}
.des_item_s1 {
  color: $primary-color;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.des_item_s2 {
  cursor: default;
}
.ml10 {
  margin-left: 10px;
}
.view_box {
  margin-top: 30px;
}

.value_box {
  // min-width: 380px;
  // max-width: 600px;
  width: 400px;
}

.empty_box {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
}

.txt1 {
  color: #ffa500;
}
.download_text {
  color: $primary-color;
  cursor: pointer;
  margin-left: 8px;
}
</style>
